import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PageHeader = ({ header, inline, className }) => {
  const classes = classNames(inline ? 'inline' : null, className);
  const props = {};

  if (classes !== '') {
    props.className = classes;
  }

  return (
    <h2 {...props}>
      {header}
    </h2>
  );
};

PageHeader.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  inline: PropTypes.bool
};

PageHeader.defaultProps = {
  className: null,
  header: '',
  inline: false
};

export default PageHeader;
